var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivateChannel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#0BABFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54159 6.15365C6.54159 5.46329 7.10123 4.90365 7.79159 4.90365H8.20825C8.89861 4.90365 9.45825 5.46329 9.45825 6.15365V6.57031H6.54159V6.15365ZM5.70825 6.57031H4.87492H4.45825V6.98698V11.5138V11.9305H4.87492H11.1249H11.5416V11.5138V6.98698V6.57031H11.1249H10.2916V6.15365C10.2916 5.00305 9.35885 4.07031 8.20825 4.07031H7.79159C6.64099 4.07031 5.70825 5.00305 5.70825 6.15365V6.57031ZM5.29159 11.0972V7.40365H10.7083V11.0972H5.29159Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateChannel);
export default __webpack_public_path__ + "static/media/privateChannel.d6b1ea80c286a7c6d37bb62fe3e78864.svg";
export { ForwardRef as ReactComponent };